export default __webpack_public_path__ + "static/media/pdfIcon.0a9d75fe.svg";